import React, { useEffect, useState } from 'react';
import { Box, Button, Group, TextInput, Grid, Col, MultiSelect } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import toast from 'react-hot-toast';
import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';



export default function AmentiesTab({ id,amenities  }) {

  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [amenitieslist, setAmenitieslist] = useState([]);

  const form = useForm({
    initialValues: {
      propertyid: id || '',
      amenties: [],
    },
    validate: {
      amenties: (val) => (val ? null : 'Required'),
    }
  });


  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.Amenties}/${user.compcode}`)
        .then((response) => {
          if (response.data.status) {
            const options = response.data.data.map((amenties) => ({
              value: amenties.id.toString(),
              label: amenties.amenitiesname,
            }));
            setAmenitieslist(options);
  
            // ⭐ Set form initial value for amenities here
            if (amenities && amenities.length > 0) {
              form.setFieldValue('amenties', amenities);
            }
            
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error('Error fetching amenities:', error);
          setLoading(false);
        });
    }
  }, [id, user.compcode, amenities]);
  


  const handleSubmit = async (values) => {
    
     
      if (!values.propertyid) {
        toast.error('Save property overview first...');
        return; // stop form submission if property ID is missing
      }
       
      const payload = [
        {
          path: "/amenities",
          op: "replace",
          value: JSON.stringify(values.amenties), // correct to stringify array
        }
      ];
      setLoading(true);
      
      try {
        const response = await axios.patch(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.ProjectOverview_Patch}/${values.propertyid}`, payload
        );
        
        if (response.data.status) {
          toast.success('Amenties Saved successfully');
          // form.reset();
          // form.setFieldValue('propertyid', values.propertyid.toString());
          // alert(response.data.amenities) 
          // form.setFieldValue('amenties', response.data.amenities); 

        } else {
          toast.error(response.data.message || 'Failed to save');
        }
        setLoading(false);

      } catch (err) {
        setLoading(false);
        console.error(err);
        toast.error('Error submitting form');
      }
  };

 



  if (loading) return <LoaderOverlay />;

  return (
    <Box>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid gutter="md">
          {/* Left side: col-8 */}
          <Col span={12} md={12}>
            <Grid gutter="md">
              <Col span={12} >
                <MultiSelect
                  label="Amenities"
                  placeholder="Select Amenities"
                  data={amenitieslist}
                  value={form.values.amenties}
                  onChange={(value) => form.setFieldValue('amenties', value)}
                  searchable
                  nothingFound="No options"
                />
              </Col>
              <Col span={12} >
                <Group position="right" mt="md">
                  <Button type="submit">Save</Button>
                  <Button variant="outline" onClick={() => navigate('/dashboard/floorplans')}>
                    Cancel
                  </Button>
                </Group>
              </Col>

            </Grid>
          </Col>

        

        </Grid>

      </form>
    </Box>
  );
}
